import script from "./TeacherBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherBanner.vue?vue&type=script&setup=true&lang=js"

import "./TeacherBanner.vue?vue&type=style&index=0&id=b810c16a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b810c16a"]])

export default __exports__